import _orderBy from 'lodash/orderBy';

const creditSortOrder = (credits): any[] => {
  const sortedCredits = _orderBy(
    credits,
    [(c) => c.creditOrder, (c) => c.year, (c) => c.title, (c) => c.role, (c) => c.director],
    ['desc', 'desc', 'asc', 'asc', 'asc']
  );
  return sortedCredits.slice(0, 3);
};

export default creditSortOrder;
